import { render } from "./hotHeader.vue?vue&type=template&id=2068bdc8&scoped=true"
import script from "./hotHeader.vue?vue&type=script&lang=js"
export * from "./hotHeader.vue?vue&type=script&lang=js"

import "./hotHeader.vue?vue&type=style&index=0&id=2068bdc8&lang=less&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2068bdc8"]])

export default __exports__